<template>
    <div>
        <div class="card" v-if="loaded">
              <div class="card-header">
                  <p class="card-header-title">{{character}}</p>
              </div>
              <div class="card-content">
                  <!-- VIP INFO -->
                    <article class="message is-info is-small" v-if="char.isvip>0">
                        <div class="message-body">
                            Los personajes con Pase VIP <fa icon="award" /> <br>pueden hacer un Reset a nivel 400 y obtienen un 50% de descuento.
                        </div>
                    </article>
                    <!-- CHARACTER INFO -->
                  <div class="columns is-mobile">
                      <div class="column">
                          <b>Resets:</b> <br> 
                          {{char.resets}}
                      </div>
                      <div class="column">
                          <b>Nivel:</b> <br> 
                          <span :class="[char.isvip>0 ? (char.clevel >= resetConditions.level.vip ? 'has-text-success':''):(char.clevel >= resetConditions.level.normal ? 'has-text-success':'')]">
                              {{char.clevel}} <fa icon="award" v-if="char.isvip>0 && char.clevel >= resetConditions.level.vip" v-tooltip="{ content: 'Nivel VIP' }" />
                            </span>
                      </div>
                  </div>
                  <hr>
                  <h4 class="title is-5 has-text-grey-dark">Cartera</h4>
                  <div class="columns">
                    <div class="column">
                        <div class="field mc-hand" @click="paytype='credits'">
                            <label class="label has-text-grey mc-hand">
                                Créditos
                            </label>
                            <p class="help">{{numberFormat(credits)}}</p>
                            <div class="control has-text-centered">
                                <label class="radio">
                                    <input type="radio" name="paytype" v-model="paytype" value="credits">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field mc-hand" @click="paytype='zenbank'">
                            <label class="label has-text-link mc-hand">
                                Banca Web
                            </label>
                            <p class="help">{{numberFormat(zenBank)}}</p>
                            <div class="control has-text-centered">
                                <label class="radio">
                                    <input type="radio" name="paytype" v-model="paytype" value="zenbank">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field mc-hand" @click="paytype='zen'">
                            <label class="label has-text-warning mc-hand">
                                Zen
                            </label>
                            <p class="help">{{numberFormat(char.money)}}</p>
                            <div class="control has-text-centered">
                                <label class="radio">
                                    <input type="radio" name="paytype" v-model="paytype" value="zen">
                                </label>
                            </div>
                        </div>
                    </div>            
                  </div>
                  <hr>
                  <h4 class="title is-5 has-text-grey-dark">Costo</h4>
                    <article :class="{'message':true, 'is-warning':paytype=='zen','is-dark':paytype=='credits', 'is-link':paytype=='zenbank'}">
                        <div class="message-body">
                            <span v-if="paytype=='credits'">{{numberFormat( ( costs.reset.credits * (char.resets+1) ) / (char.isvip>0 ? 2:1 )) }} Créditos <fa icon="award" v-if="char.isvip>0" v-tooltip="{ content: 'Precio VIP' }" /></span>
                            <span v-else>{{numberFormat( ( costs.reset.zen * ( char.resets+1 ) )  / (char.isvip>0 ? 2:1 ))  }} Zen <fa icon="award" v-if="char.isvip>0" v-tooltip="{ content: 'Precio VIP' }" /></span>
                        </div>
                    </article>
              </div>
              <footer class="card-footer">
                <a @click="$emit('go-back')" class="card-footer-item has-text-link">Volver</a>
                <a  class="card-footer-item has-text-success"
                    @click="verifyReset()"
                    v-if="showResetButton()">RESET</a>
                <p class="card-footer-item" v-else>
                    <span>
                        {{noResetMessage}}
                    </span>
                </p>
              </footer>
        </div>
        <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin/>
    </div>
</template>

<script>
import UserService from '@/services/user.service.js';
import Swal from 'sweetalert2'
export default {
    name:'DashboardCharacterReset',
    props: ['user'],
    watch: {
        character: function() {
            this.setUpData()
        }
    },
    data:()=>({
        loaded:false,
        char: {
            resets:0,
            clevel:0,
            money:0,
            isvip:0,
        },
        credits:0,
        zenBank:0,
        paytype:'zen'
    }),
    async created() {
        await this.setUpData()
        this.loaded = true
    },
    computed: {
        endpoint() {
            return this.$store.getters.GetEndpoints.dashboard.server.stat
        },
        character() {
            return this.$store.getters.GetDashboardData.character
        },
        numberFormat() {
            return this.$store.getters.numberWithCommas
        },
        costs() {
            return this.$store.getters.costs
        },
        resetConditions() {
            return this.$store.getters.resetConditions
        },
        messages() {
            return this.$store.getters.GetMessages
        }
    },
    methods: {
        showResetButton() {
            if(this.char.resets >= 100) {
                this.noResetMessage = this.character+' ha alcanzado el limite de resets.'
                return false
            }
            if(this.char.isvip>0) {
                if( this.char.clevel < this.resetConditions.level.vip ) {
                    this.noResetMessage = 'No tiene el nivel necesario.'
                    return false
                }
                var cost = 0
                switch(this.paytype) {
                    case 'credits':
                        cost = ( this.costs.reset.credits * (this.char.resets+1 ) ) / 2
                        if (this.credits < cost) {
                            this.noResetMessage = 'No tiene suficientes Créditos.'
                            return false
                        }
                        break;
                    case 'zenbank':
                        cost = (this.costs.reset.zen * (this.char.resets+1)) / 2
                        if (this.zenBank < cost) {
                            this.noResetMessage = 'No hay suficiente Zen en el Banco.'
                            return false
                        }
                        break;
                    default:
                        cost = (this.costs.reset.zen * (this.char.resets+1)) / 2
                        if (this.char.money < cost) {
                            this.noResetMessage = this.character+' no tiene suficiente Zen.'
                            return false
                        }
                        break;
                }
            } else {
                if(this.char.clevel < this.resetConditions.level.normal) {
                    this.noResetMessage = 'No tiene el nivel necesario.'
                    return false
                }
                switch(this.paytype) {
                    case 'credits':
                        cost = this.costs.reset.credits * (this.char.resets+1)
                        if (this.credits < cost) {
                            this.noResetMessage = 'No tiene suficientes Créditos.'
                            return false
                        }
                        break;
                    case 'zenbank':
                        cost = this.costs.reset.zen * (this.char.resets+1)
                        if (this.zenBank < cost) {
                            this.noResetMessage = 'No hay suficiente Zen en el Banco.'
                            return false
                        }
                        break;
                    default:
                        cost = this.costs.reset.zen * (this.char.resets+1)
                        if (this.char.money < cost) {
                            this.noResetMessage = this.character+' no tiene suficiente Zen.'
                            return false
                        }
                        break;
                }

            }

            return true
        },
        verifyReset() {
            Swal.fire({
                title: '<strong>Nuevo Reset de <u>'+this.character+'</u></strong>',
                icon: 'warning',
                html:
                    '<div><b>'+this.character+'</b> ahora tendrá <b>'+(this.char.resets+1)+' Resets</b>, <br>' +
                    'después de la operación te quedaran '+this.numberFormat(this.resetRemainder().remain)+' de '+this.resetRemainder().name+'.<br><br>' +
                    '<article class="message is-link"><div class="message-body">' +
                     this.messages.preventPlay +
                    '</div> </article>' +
                    '<b>¿Desea proceder?</b> </div>',
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'OK!',
                cancelButtonText:
                    'Mejor no.'
            }).then((result) => {
                if (result.value) {
                    this.reset()
                }
            })
        },
        async reset() {
            this.$store.commit('setLoader', true)
            const formData = { type:this.paytype}
            await UserService.updateCharacterReset(this.character, formData)
                .then(response => {
                    this.$store.commit('setLoader', false)
                    var result = response.data
                    this.char.resets = result.resets
                    this.char.clevel = result.clevel
                    this.char.money = result.money
                    Swal.fire({
                        position: 'top',
                        icon: 'success',
                        title: `${this.character} ha recibido un Reset!`,
                        showConfirmButton: false,
                        timer: 2000,
                        showClass: {
                            popup: 'animated fadeInDown faster'
                        },
                        hideClass: {
                            popup: 'animated fadeOutUp faster'
                        }
                    }).then(()=>{
                        this.$store.dispatch('setDashboardData', {page:11})
                    })
                })
                .catch(error => {
                    var apiError = error.response.data,
                        message = ''
                    if ('info' in apiError) message = apiError.info
                    else if(apiError.status_code==403) message = 'Tu cuenta debe permanecer desconectada del juego para lograr hacer un Reset.'
                    else message = 'Ops, Ha ocurrido un error! Intente de nuevo.'

                    this.$toasted.show(message, { 
                        theme: 'toasted-danger', 
                        position: "top-center", 
                        duration : 5000
                    });
                    this.$store.commit('setLoader', false)
                })
        },
        resetRemainder() {
            var name = 'Zen'
            var remain = 0
            var cost = 0
            if(this.char.isvip>0) {
                switch(this.paytype) {
                    case 'credits':
                        cost = (this.costs.reset.credits * (this.char.resets+1))/2
                        name = 'Créditos'
                        remain = (this.credits - cost)
                        break;
                    case 'zenbank':
                        cost = (this.costs.reset.zen * (this.char.resets+1))/2
                        remain = (this.zenBank - cost)
                        break;
                    default:
                        cost = (this.costs.reset.zen * (this.char.resets+1))/2
                        remain = (this.char.money - cost)
                        break;
                } 
            } else {
                switch(this.paytype) {
                    case 'credits':
                        cost = this.costs.reset.credits * (this.char.resets+1)
                        name = 'Créditos'
                        remain = (this.credits - cost)
                        break;
                    case 'zenbank':
                        cost = this.costs.reset.zen * (this.char.resets+1)
                        remain = (this.zenBank - cost)
                        break;
                    default:
                        cost = this.costs.reset.zen * (this.char.resets+1)
                        remain = (this.char.money - cost)
                        break;
                }      
            }
            return {remain: remain, name:name}
        },
        async setUpData() {
            this.loaded = false
            let {data} = await UserService.getCharacterReset(this.character)
            this.char.resets = data.resets
            this.char.clevel = data.clevel
            this.char.money = data.money
            this.char.isvip = data.isvip

            await UserService.getWebBank(this.user.pk)
                .then(response => {
                    var result = response.data
                    this.credits = result.credits.credits
                    this.zenBank = result.zen.zen
                })

            this.loaded = true
        }
    }
}
</script>

<style scoped>
    .mc-hand {
        cursor: pointer !important;
    }
    .mc-hand:hover {
        opacity: .8;
    }
</style>